import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/BankAccount";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const BankAccountDetails = (options) =>
  GENERATE_URL(`${PREFIX_URL}/BankAccountDetails`, options);

export const MikroBankAccounts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MikroBankAccounts`, options);

export const MikroBankAccountDetails = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MikroBankAccountDetails`, options);

export default {
  GetAll,
  Create,
  Update,
  Delete,
  BankAccountDetails,
  MikroBankAccounts,
  MikroBankAccountDetails,
};
